import e from "../_virtual/_plugin-vue_export-helper.js";
import t from "./SchemaComposition.vue.script.js";
/* empty css                                */
//#region src/schema/SchemaComposition.vue
var n = /*#__PURE__*/ e(t, [["__scopeId", "data-v-c738e9ab"]]);
//#endregion
export { n as default };

//# sourceMappingURL=SchemaComposition.vue.js.map